import React from "react";
import { Star, ExternalLink } from "lucide-react";
import SectionHeading from "./SectionHeading";
import { Reveal } from "../hooks/useReveal";
import { REVIEWS, BRAND } from "../mock";

const PLATFORMS = [
  { label: "Google", href: BRAND.social.google, rating: "4.7" },
  { label: "Yelp", href: BRAND.social.yelp, rating: "4.5" },
  { label: "Apple Maps", href: BRAND.social.apple, rating: "4.6" },
];

export default function Reviews() {
  return (
    <section className="relative py-24 md:py-32 bg-nala-black">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <SectionHeading
          eyebrow="Guest Experiences"
          title="Loved Across Atlanta"
          subtitle="Rated 5 stars by hundreds of guests who came to celebrate."
        />

        {/* Platform ratings */}
        <Reveal className="flex flex-wrap justify-center gap-4 mt-10">
          {PLATFORMS.map((p) => (
            <a
              key={p.label}
              href={p.href}
              target="_blank"
              rel="noreferrer"
              className="group flex items-center gap-3 border border-nala-gold/25 bg-nala-charcoal/60 px-6 py-3 hover:border-nala-gold transition-colors"
            >
              <span className="text-nala-cream text-sm tracking-wide-lux">{p.label}</span>
              <span className="flex items-center gap-1 text-nala-gold text-sm">
                <Star size={14} className="fill-nala-gold" /> {p.rating}
              </span>
              <ExternalLink size={13} className="text-nala-cream-muted group-hover:text-nala-gold transition-colors" />
            </a>
          ))}
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {REVIEWS.map((r, i) => (
            <Reveal
              key={r.name}
              delay={i * 80}
              className="bg-nala-charcoal border border-nala-gold/12 p-8 hover:border-nala-gold/40 transition-all duration-500 hover:-translate-y-1"
            >
              <div className="flex gap-0.5 mb-4 text-nala-gold">
                {Array.from({ length: r.rating }).map((_, k) => (
                  <Star key={k} size={16} className="fill-nala-gold" />
                ))}
              </div>
              <p className="font-serif-lux text-lg text-nala-cream leading-relaxed italic">"{r.text}"</p>
              <div className="mt-6 pt-5 border-t border-white/8">
                <p className="text-nala-cream font-medium tracking-wide-lux text-sm">{r.name}</p>
                <p className="text-nala-cream-muted text-xs mt-1">{r.meta}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-12">
          <a href={BRAND.social.google} target="_blank" rel="noreferrer" className="btn-outline-gold">
            <span>Leave a Review</span>
          </a>
        </div>
      </div>
    </section>
  );
}
